import { useState } from "react";
import { ArrowsClockwise, Bank } from "@phosphor-icons/react";
import { SiStripe, SiQuickbooks } from "react-icons/si";
import { toast } from "sonner";
import { useApi, errText } from "@/lib/api";
import { useCanEdit, VIEW_ONLY_TIP } from "@/components/app/TrialBanner";

const SRC = [["stripe", SiStripe, "#635BFF", "Stripe"], ["bank", Bank, "#00FF9D", "Bank"], ["qbo", SiQuickbooks, "#2CA01C", "QBO"]];

export const SourceBar = ({ sources, sync, onSynced }) => {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const syncAll = async () => {
    setBusy(true);
    try {
      await Promise.all(SRC.map(([s]) => api.post(`/sync/${s}`)));
      toast.success("Multi-Sync complete");
      onSynced();
    } catch (e) { toast.error(errText(e, "Sync failed")); }
    setBusy(false);
  };
  const canEdit = useCanEdit();
  return (
    <div className="flex flex-wrap items-center gap-2">
      {SRC.map(([key, Icon, color, label]) => (
        <span key={key} data-testid={`source-${key}`} title={sync?.[key] ? `Synced ${new Date(sync[key]).toLocaleString()}` : ""}
          className="flex items-center gap-2 rounded-full border border-[#2A2A2A] bg-[#0B0B0B] px-3 py-1.5 text-xs">
          <Icon style={{ color }} /> {label}
          <span className={`font-mono text-[10px] ${sources[key] === "live" ? "text-[#00FF9D]" : "text-[#A3A3A3]"}`}>
            {sources[key] === "live" ? "LIVE" : "DEMO"}
          </span>
        </span>
      ))}
      <button data-testid="tri-sync-btn" onClick={syncAll} disabled={busy || !canEdit} title={canEdit ? undefined : VIEW_ONLY_TIP} style={canEdit ? undefined : { opacity: 0.35, cursor: "not-allowed" }}
        className="flex items-center gap-2 rounded-full bg-[#00FF9D] px-4 py-1.5 text-xs font-semibold text-[#050505] hover:shadow-[0_0_20px_rgba(0,255,157,0.5)] transition-shadow disabled:opacity-60">
        <ArrowsClockwise className={busy ? "animate-spin" : ""} weight="bold" /> Sync now
      </button>
    </div>
  );
};
